// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@vanmeter/XDL/constants";
import { avoidBreakInsidePrintElement, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

interface OrderInformationStyles {
    label?: TypographyProps;
    value?: TypographyProps;
    infoLabel?: TypographyProps;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
    address?: { heading?: TypographyProps; informationTitle?: TypographyProps } & AddressInfoDisplayStyles;
    note?: { wrapper?: InjectableCss; title?: TypographyProps; text?: TypographyProps };
    orderSummary?: any;
}

const xOrderInformationStyles: OrderInformationStyles = {
    label: {
        variant: "h6",
        css: css`
            margin-right: 4px;
            margin-bottom: 0;
            @media print {
                display: block;
            }
        `,
    },
    value: {
        variant: "h6",
        weight: fontConfig.weight.regular,
        css: css`
            margin-bottom: 0;
            &:empty:after {
                content: "- -";
            }
            @media print {
                display: inline-block;
                width: auto;
            }
        `,
    },
    address: {
        informationTitle: {
            variant: "h5",
            as: "h2",
        },
        heading: {
            variant: "h6",
        },
    },
    note: {
        text: {
            variant: "h6",
            weight: fontConfig.weight.regular,
            css: css`
                margin-bottom: 0;
            `,
        },
    },
    orderSummary: {
        css: css`
            ${avoidBreakInsidePrintElement}
            ${xScreen("lte", "md")} {
                margin-bottom: 10px;
            }
        `,
    },
};

xOrderInformationStyles.infoLabel = {
    variant: "h6",
    transform: "none",
    css: css`
        margin-bottom: 0;
        white-space: nowrap;
        @media print {
            display: inline-block;
            margin-right: 4px;
            width: auto;
        }
    `,
};

xOrderInformationStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            @media print {
                display: block;
            }
        `,
    },
    heading: {
        ...xOrderInformationStyles.infoLabel,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};

export default xOrderInformationStyles;
